(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dogma-collar-personalization-script"] && !Shopify.designMode) return;
  try {
    class DogmaCollarPersonalization {
    constructor(root) {
      this.root = root;
      this.maxSigns = Number(root.dataset.maxSigns || 6);
      this.pricePerSign = Number(root.dataset.pricePerSign || 150);
      this.currency = root.dataset.currency || 'EUR';
      this.basePrice = Number(root.dataset.basePrice || 0);
      this.charmProductHandle = root.dataset.charmProductHandle || '';
      this.form = document.getElementById(root.dataset.productFormId);
      this.nameInput = root.querySelector('[data-dogma-name]');
      this.symbolInput = root.querySelector('[data-dogma-symbol]');
      this.positionInput = root.querySelector('[data-dogma-position]');
      this.counter = root.querySelector('[data-dogma-counter]');
      this.error = root.querySelector('[data-dogma-error]');
      this.slots = root.querySelector('[data-dogma-slots]');
      this.addonPrice = root.querySelector('[data-dogma-addon-price]');
      this.totalPrice = root.querySelector('[data-dogma-total-price]');
      this.i18n = this.readI18n();
      this.properties = {
        name: root.querySelector('[data-dogma-property="name"]'),
        sequence: root.querySelector('[data-dogma-property="sequence"]'),
        count: root.querySelector('[data-dogma-property="count"]'),
        size: root.querySelector('[data-dogma-property="size"]'),
        price: root.querySelector('[data-dogma-property="price"]'),
        components: root.querySelector('[data-dogma-property="components"]')
      };
      this.palette = [
        { name: 'Purple', label: this.i18n.colors?.Purple || 'Purple', value: '#9b75ff' },
        { name: 'Pink', label: this.i18n.colors?.Pink || 'Pink', value: '#ff8fb7' },
        { name: 'Yellow', label: this.i18n.colors?.Yellow || 'Yellow', value: '#ffd94d' },
        { name: 'Sky blue', label: this.i18n.colors?.['Sky blue'] || 'Sky blue', value: '#75cfff' },
        { name: 'Navy', label: this.i18n.colors?.Navy || 'Navy', value: '#203f87' }
      ];
      this.colorState = [];
      this.variantId = '';
      this.variants = this.readVariants();
      this.fallbackCharmVariants = this.readFallbackCharmVariants();
      this.charmVariantMap = new Map();
      this.isLoadingCharmProduct = Boolean(this.charmProductHandle);
      this.componentLoadError = false;
      this.isSubmitting = false;
      this.bind();
      this.applyFallbackCharmVariants();
      this.update();
      this.loadCharmProduct();
    }

    readI18n() {
      const fallback = {
        signsCounter: '{{ count }} / {{ max }} signs',
        maxError: 'Maximum {{ max }} signs. Please shorten the name or remove the extra charm.',
        loadingError: 'Personalization stock is loading. Please try again in a moment.',
        componentsError: 'Personalization components could not be loaded. Please refresh the page and try again.',
        unavailableError: '{{ sign }} in {{ color }}, {{ size }} is currently out of stock.',
        chooseSizeError: 'Please choose a collar size before adding personalization.',
        addError: 'Could not add personalization to cart.',
        personalizedCollar: 'Personalized collar',
        componentPropertyForDog: 'For dog',
        componentPropertyPersonalization: 'Collar personalization',
        symbols: {
          HEART: 'Heart',
          PAW: 'Paw',
          STAR: 'Star',
          FLOWER: 'Flower',
          Heart: 'Heart',
          Paw: 'Paw',
          Star: 'Star',
          Flower: 'Flower'
        },
        colors: {
          Purple: 'Purple',
          Pink: 'Pink',
          Yellow: 'Yellow',
          'Sky blue': 'Sky blue',
          Navy: 'Navy'
        }
      };
      const script = this.root.querySelector('[data-dogma-i18n]');
      if (!script) return fallback;

      try {
        const parsed = JSON.parse(script.textContent);
        return {
          ...fallback,
          ...parsed,
          symbols: { ...fallback.symbols, ...(parsed.symbols || {}) },
          colors: { ...fallback.colors, ...(parsed.colors || {}) }
        };
      } catch (error) {
        return fallback;
      }
    }

    readVariants() {
      const script = this.root.querySelector('[data-dogma-variants]');
      if (!script) return [];

      try {
        return JSON.parse(script.textContent);
      } catch (error) {
        return [];
      }
    }

    readFallbackCharmVariants() {
      const script = this.root.querySelector('[data-dogma-fallback-charm-variants]');
      if (!script) return [];

      try {
        const fallbackData = JSON.parse(script.textContent);
        if (Array.isArray(fallbackData)) return fallbackData;

        const signs = fallbackData.signs || [];
        const sizes = fallbackData.sizes || [];
        const step = Number(fallbackData.step || 0);

        return sizes.flatMap((size) =>
          signs.map((sign, index) => ({
            id: Number(size.start) + index * step,
            option1: sign,
            option2: fallbackData.color,
            option3: size.name,
            available: true,
            fallback: true
          }))
        );
      } catch (error) {
        return [];
      }
    }

    bind() {
      this.nameInput?.addEventListener('input', () => this.update());
      this.symbolInput?.addEventListener('change', () => this.update());
      this.positionInput?.addEventListener('change', () => this.update());
      this.form?.addEventListener('change', () => this.update());

      const variantInput = this.getVariantInput();
      if (variantInput) {
        this.variantId = variantInput.value;
        new MutationObserver(() => this.update()).observe(variantInput, {
          attributes: true,
          attributeFilter: ['value']
        });
      }
    }

    async loadCharmProduct() {
      if (!this.charmProductHandle) {
        this.isLoadingCharmProduct = false;
        this.update();
        return;
      }

      const rootPath = window.Shopify?.routes?.root || '/';

      try {
        const response = await fetch(`${rootPath}products/${this.charmProductHandle}.js`, {
          headers: { Accept: 'application/json' }
        });

        if (!response.ok) {
          throw new Error(this.i18n.componentsError);
        }

        const product = await response.json();
        (product.variants || []).forEach((variant) => this.registerCharmVariant(variant));
        this.applyFallbackCharmVariants();
      } catch (error) {
        this.componentLoadError = true;
      } finally {
        this.isLoadingCharmProduct = false;
        this.update();
      }
    }

    applyFallbackCharmVariants() {
      this.fallbackCharmVariants.forEach((variant) => this.registerCharmVariant(variant, true));
    }

    registerCharmVariant(variant, preserveExisting = false) {
      const sign = variant.option1 || variant.options?.[0];
      const color = variant.option2 || variant.options?.[1];
      const size = variant.option3 || variant.options?.[2];

      if (!sign || !color || !size || !variant.id) return;

      const key = this.getCharmKey(sign, color, size);
      if (preserveExisting && this.charmVariantMap.has(key)) return;

      this.charmVariantMap.set(key, {
        id: Number(variant.id),
        sign,
        color,
        size,
        available: variant.available !== false,
        fallback: Boolean(variant.fallback)
      });
    }

    getVariantInput() {
      return this.form?.querySelector('[name="id"]');
    }

    getSubmitButton() {
      return this.form?.querySelector('[type="submit"]');
    }

    getCleanName() {
      const inputValue = this.nameInput?.value || '';
      const cleanValue = inputValue.toUpperCase().replace(/[^A-Z]/g, '');

      if (this.nameInput && this.nameInput.value !== cleanValue) {
        this.nameInput.value = cleanValue;
      }

      return cleanValue;
    }

    getSigns() {
      const letters = this.getCleanName().split('').map((letter) => ({
        type: 'letter',
        label: letter
      }));

      const symbol = this.symbolInput?.value || '';
      if (!symbol) return letters;

      const symbolSign = {
        type: 'symbol',
        label: symbol
      };

      if (this.positionInput?.value === 'before') {
        return [symbolSign].concat(letters);
      }

      return letters.concat(symbolSign);
    }

    getVariantByCurrentSelection() {
      const variantInput = this.getVariantInput();
      const currentId = String(variantInput?.value || '');
      return this.variants.find((item) => String(item.id) === currentId);
    }

    getCurrentBasePrice() {
      const variant = this.getVariantByCurrentSelection();
      const variantPrice = Number(variant?.price);

      if (!Number.isNaN(variantPrice) && variantPrice > 0) {
        return variantPrice;
      }

      return this.basePrice;
    }

    formatMoney(cents) {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: this.currency
      }).format(cents / 100);
    }

    formatTemplate(template, values = {}) {
      return String(template || '').replace(/\{\{\s*(\w+)\s*\}\}/g, (match, key) => values[key] ?? '');
    }

    normalizeSignLabel(label) {
      const symbolLabels = {
        HEART: 'Heart',
        PAW: 'Paw',
        STAR: 'Star',
        FLOWER: 'Flower'
      };

      return symbolLabels[label] || label;
    }

    displaySignLabel(label) {
      return this.i18n.symbols?.[label] || this.i18n.symbols?.[this.normalizeSignLabel(label)] || label;
    }

    getColorLabel(colorName) {
      return this.i18n.colors?.[colorName] || colorName;
    }

    getCharmSize() {
      const variant = this.getVariantByCurrentSelection();
      const source = [variant?.title, ...(variant?.options || [])].join(' ').toLowerCase();

      if (source.includes('20 mm') || source.includes('20mm') || source.includes('width 20')) {
        return '20 mm';
      }

      return '25 mm';
    }

    getCharmKey(sign, color, size) {
      return `${this.normalizeSignLabel(sign)}|${color}|${size}`;
    }

    getCharmVariant(sign, color, size) {
      return this.charmVariantMap.get(this.getCharmKey(sign, color, size));
    }

    getCharmLines(signs) {
      const size = this.getCharmSize();

      return signs.slice(0, this.maxSigns).map((sign, index) => {
        const color = this.colorState[index] || this.palette[0].name;
        const variant = this.getCharmVariant(sign.label, color, size);

        return {
          sign,
          color,
          size,
          variant
        };
      });
    }

    getUnavailableLine(signs) {
      return this.getCharmLines(signs).find((line) => !line.variant || line.variant.available === false);
    }

    renderSlots(signs) {
      this.colorState = signs.map((sign, index) => this.colorState[index] || this.palette[index % this.palette.length].name);
      this.colorState = this.colorState.slice(0, signs.length);
      this.slots.innerHTML = '';

      const charmSize = this.getCharmSize();

      signs.slice(0, this.maxSigns).forEach((sign, index) => {
        const activeColor = this.palette.find((color) => color.name === this.colorState[index]) || this.palette[0];
        const charmVariant = this.getCharmVariant(sign.label, activeColor.name, charmSize);
        const slot = document.createElement('div');
        slot.className = 'dogma-personalization__slot';
        slot.classList.toggle(
          'is-unavailable',
          !this.isLoadingCharmProduct && (!charmVariant || charmVariant.available === false)
        );

        const charm = document.createElement('div');
        charm.className = 'dogma-personalization__charm';
        charm.style.setProperty('--dogma-charm-color', activeColor.value);
        charm.textContent = sign.label;
        slot.appendChild(charm);

        const colors = document.createElement('div');
        colors.className = 'dogma-personalization__colors';

        this.palette.forEach((color) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'dogma-personalization__color';
          button.style.setProperty('--dogma-swatch', color.value);
          button.setAttribute('aria-label', color.label || color.name);
          button.classList.toggle('is-active', color.name === activeColor.name);
          button.addEventListener('click', () => {
            this.colorState[index] = color.name;
            this.update();
          });
          colors.appendChild(button);
        });

        slot.appendChild(colors);
        this.slots.appendChild(slot);
      });
    }

    updateProperties(signs, addonPrice) {
      const charmSize = this.getCharmSize();
      const sequence = signs
        .slice(0, this.maxSigns)
        .map((sign, index) => {
          const colorName = this.colorState[index] || this.palette[0].name;

          return `${this.displaySignLabel(sign.label)} (${this.getColorLabel(colorName)}, ${charmSize})`;
        })
        .join(', ');

      if (this.properties.name) this.properties.name.value = this.getCleanName();
      if (this.properties.sequence) this.properties.sequence.value = sequence;
      if (this.properties.count) this.properties.count.value = String(signs.length);
      if (this.properties.size) this.properties.size.value = signs.length ? charmSize : '';
      if (this.properties.price) this.properties.price.value = this.formatMoney(addonPrice);
      if (this.properties.components) this.properties.components.value = signs.length ? 'true' : '';
    }

    setSubmitBlocked(isBlocked) {
      const submitButton = this.getSubmitButton();
      if (!submitButton) return;

      if (isBlocked) {
        if (!submitButton.disabled) {
          submitButton.disabled = true;
          submitButton.dataset.dogmaDisabled = 'true';
        } else {
          submitButton.setAttribute('aria-disabled', 'true');
          submitButton.dataset.dogmaAriaDisabled = 'true';
        }
        return;
      }

      if (submitButton.dataset.dogmaDisabled === 'true') {
        submitButton.disabled = false;
        delete submitButton.dataset.dogmaDisabled;
      }

      if (submitButton.dataset.dogmaAriaDisabled === 'true') {
        submitButton.removeAttribute('aria-disabled');
        delete submitButton.dataset.dogmaAriaDisabled;
      }
    }

    getValidation(signs) {
      if (signs.length > this.maxSigns) {
        return {
          blocked: true,
          message: this.formatTemplate(this.i18n.maxError, { max: this.maxSigns })
        };
      }

      if (signs.length && this.isLoadingCharmProduct) {
        return {
          blocked: true,
          message: this.i18n.loadingError
        };
      }

      if (signs.length && this.componentLoadError) {
        return {
          blocked: true,
          message: this.i18n.componentsError
        };
      }

      const unavailableLine = this.getUnavailableLine(signs);

      if (unavailableLine) {
        return {
          blocked: true,
          message: this.formatTemplate(this.i18n.unavailableError, {
            sign: this.displaySignLabel(unavailableLine.sign.label),
            color: this.getColorLabel(unavailableLine.color),
            size: unavailableLine.size
          })
        };
      }

      return {
        blocked: false,
        message: ''
      };
    }

    showError(message) {
      this.error.hidden = !message;
      this.error.textContent = message || '';
    }

    update() {
      const signs = this.getSigns();
      const addonPrice = signs.length * this.pricePerSign;
      const totalPrice = this.getCurrentBasePrice() + addonPrice;
      const validation = this.getValidation(signs);

      this.counter.textContent = this.formatTemplate(this.i18n.signsCounter, {
        count: signs.length,
        max: this.maxSigns
      });
      this.renderSlots(signs);
      this.updateProperties(signs, addonPrice);
      this.addonPrice.textContent = this.formatMoney(addonPrice);
      this.totalPrice.textContent = this.formatMoney(totalPrice);
      this.showError(validation.message);
      this.setSubmitBlocked(validation.blocked || this.isSubmitting);
    }

    setSubmitting(isSubmitting) {
      this.isSubmitting = isSubmitting;
      const submitButton = this.getSubmitButton();
      if (!submitButton) return;

      if (isSubmitting) {
        submitButton.disabled = true;
        submitButton.dataset.dogmaSubmitting = 'true';
        return;
      }

      if (submitButton.dataset.dogmaSubmitting === 'true') {
        submitButton.disabled = false;
        delete submitButton.dataset.dogmaSubmitting;
      }
    }

    getFormProperties(formData) {
      const properties = {};

      formData.forEach((value, key) => {
        if (!key.startsWith('properties[')) return;
        if (value === '') return;

        const propertyName = key.slice(11, -1);
        properties[propertyName] = String(value);
      });

      return properties;
    }

    buildBaseItem(formData) {
      const quantity = Math.max(1, Number(formData.get('quantity') || 1));
      const item = {
        id: Number(formData.get('id')),
        quantity
      };
      const properties = this.getFormProperties(formData);
      const sellingPlan = formData.get('selling_plan');

      if (Object.keys(properties).length) item.properties = properties;
      if (sellingPlan) item.selling_plan = Number(sellingPlan);

      return item;
    }

    buildCharmItems(charmLines, collarQuantity) {
      const cleanName = this.getCleanName();
      const sequence = this.properties.sequence?.value || '';
      const groupedItems = new Map();
      const forDogProperty = this.i18n.componentPropertyForDog || 'For dog';
      const personalizationProperty = this.i18n.componentPropertyPersonalization || 'Collar personalization';

      charmLines.forEach((line) => {
        const id = Number(line.variant.id);
        const existingItem = groupedItems.get(id);

        if (existingItem) {
          existingItem.quantity += collarQuantity;
          return;
        }

        groupedItems.set(id, {
          id,
          quantity: collarQuantity,
          properties: {
            [forDogProperty]: cleanName || this.i18n.personalizedCollar,
            [personalizationProperty]: sequence,
            '_dogma_component': 'true'
          }
        });
      });

      return Array.from(groupedItems.values());
    }

    async handleSubmit(event) {
      const signs = this.getSigns();
      if (!signs.length) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (this.isSubmitting) return;

      const validation = this.getValidation(signs);
      if (validation.blocked) {
        this.showError(validation.message);
        return;
      }

      const formData = new FormData(this.form);
      const baseItem = this.buildBaseItem(formData);
      const charmLines = this.getCharmLines(signs);
      const items = [baseItem].concat(this.buildCharmItems(charmLines, baseItem.quantity));
      const rootPath = window.Shopify?.routes?.root || '/';

      if (!baseItem.id || Number.isNaN(baseItem.id)) {
        this.showError(this.i18n.chooseSizeError);
        return;
      }

      this.setSubmitting(true);
      this.showError('');

      try {
        const response = await fetch(`${rootPath}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items })
        });

        if (!response.ok) {
          const payload = await response.json().catch(() => ({}));
          throw new Error(payload.description || payload.message || this.i18n.addError);
        }

        window.location.href = window.routes?.cart_url || `${rootPath}cart`;
      } catch (error) {
        this.setSubmitting(false);
        this.update();
        this.showError(error.message || this.i18n.addError);
      }
    }
  }

  const initializeDogmaCollarPersonalization = (root) => {
    if (root.dogmaCollarPersonalization) return root.dogmaCollarPersonalization;

    const instance = new DogmaCollarPersonalization(root);
    root.dogmaCollarPersonalization = instance;
    return instance;
  };

  const initializeDogmaCollarPersonalizations = (scope = document) => {
    scope.querySelectorAll('[data-dogma-personalization]').forEach((root) => {
      initializeDogmaCollarPersonalization(root);
    });
  };

  initializeDogmaCollarPersonalizations();

  const getDogmaCollarPersonalizationForForm = (form) => {
    if (!(form instanceof HTMLFormElement)) return null;

    const formId = form.getAttribute('id');
    if (!formId) return null;

    const root = Array.from(document.querySelectorAll('[data-dogma-personalization]')).find(
      (candidate) => candidate.dataset.productFormId === formId
    );
    if (!root) return null;

    const instance = initializeDogmaCollarPersonalization(root);
    instance.form = form;
    return instance;
  };

  document.addEventListener(
    'submit',
    (event) => {
      getDogmaCollarPersonalizationForForm(event.target)?.handleSubmit(event);
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const submitter = event.target.closest?.('button[type="submit"], input[type="submit"]');
      if (!submitter?.form) return;

      getDogmaCollarPersonalizationForForm(submitter.form)?.handleSubmit(event);
    },
    true
  );

  document.addEventListener('shopify:section:load', (event) => {
    initializeDogmaCollarPersonalizations(event.target);
  });
  } catch(e) { console.error(e); }
})();

})();
